export class ThirdPartyEvaluationStage{
    id: number = null;
    stageId: number = 0;
    name: string = '';
    order: number = null;

    /**
     *
     */
    constructor() {
    }
}